module.exports = __webpack_public_path__ + "static/assets/921566822e1b90c253b0815577c6e039.svg";